import { Link } from 'react-router'
import { Panel } from '@/components/redesign/bits'
import { Skeleton } from '@/components/ui/skeleton'
import { numberFmt } from '@/lib/format'
import { useCustomerConnector } from './api'
import { CallsTable } from './calls-table'

/** On a customer's page: what they did with Arva SEO from connected AI assistants. */
export function CustomerConnectorCard({ workspaceId }: { workspaceId: string }) {
  const connector = useCustomerConnector(workspaceId)
  if (connector.isPending) return <Skeleton className="h-32 rounded-[14px]" />
  if (connector.isError) return null
  const d = connector.data

  return (
    <Panel
      title="AI connector"
      sub={
        d.recent.length === 0
          ? d.connected
            ? 'Connected, no calls recorded yet'
            : 'No AI assistant connected'
          : `${numberFmt.format(d.calls_30d)} ${d.calls_30d === 1 ? 'call' : 'calls'} in 30 days · ${d.apps.join(', ')}`
      }
      extra={
        <Link className="linkbtn" to="/ai-connector">
          All customers
        </Link>
      }
    >
      {d.recent.length > 0 && <CallsTable calls={d.recent.slice(0, 8)} showWho={false} />}
    </Panel>
  )
}
